import React, { useEffect, useState } from "react";
import "../../styles/pages/Company/onboarding.scss";
import { useEnv } from "../../context/env.context";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const CompanyOnboarding = () => {
  const [code, setCode] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState(null);
  const { apiServerUrl } = useEnv();
  const history = useHistory();

  useEffect(() => {
    const nav = document.getElementsByClassName("nav-bar__container")[0];
    if (nav) {
      nav.style = "display:none";
    }

    const container = document.getElementsByClassName("content_container")[0];
    if (container) {
      container.style = "max-width: 100%;width:100%;";
    }

    return () => {
      const nav = document.getElementsByClassName("nav-bar__container")[0];
      if (nav) {
        nav.style = "display:flex";
      }
    };
  }, []);

  const addToCrew = async () => {
      const token = await getAccessTokenSilently();

      const newCode = code.replace(/\s/g, "");

      const response = await fetch(`${apiServerUrl}/api/crews/user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          code: newCode
        }),
      });

      const data = await response.json();

      if (data?.error) {
        return setError(data.error);
      }

      window.location.href = "/company/intro";
    
  };

  return (
    <div className="CompanyOnboarding">
      <div className="input-group">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            addToCrew();
          }}
        >
          <h3>Let’s get you into your crew</h3>
          <label htmlFor="companyName">Enter your cohort code</label>
          {error && <p className="error">{error}</p>}

          <input
            onChange={(e) => {
              setCode(e.target.value);
            }}
            type="text"
            id="companyName"
            placeholder="TYPECODE"
          />
          <div className="code">
          <h5>Where do I find my code?</h5>
          <p>You can find your invite code in the email you received to join Crew</p>
          </div>
          <button
            type="submit"
            className="btn primary"
          >
            Next
          </button>
          <div className="powered-by">
        <h5>Powered by</h5>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="97"
          height="28"
          viewBox="0 0 97 28"
          fill="none"
        >
          <g clipPath="url(#clip0_772_1717)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.0552 8.14328C20.2647 7.52549 20.3782 6.8641 20.3782 6.17646C20.3782 2.76529 17.5853 0 14.1399 0C10.6947 0 7.90174 2.76529 7.90174 6.17646C7.90174 6.8641 8.01523 7.52549 8.22468 8.14327C7.60071 7.9359 6.93271 7.82352 6.2382 7.82352C2.79294 7.82352 0 10.5888 0 14C0 17.4111 2.79294 20.1765 6.2382 20.1765C6.93271 20.1765 7.60073 20.0641 8.22468 19.8568C8.01523 20.4744 7.90174 21.1359 7.90174 21.8235C7.90174 25.2347 10.6947 28 14.1399 28C17.5853 28 20.3782 25.2347 20.3782 21.8235C20.3782 21.1359 20.2647 20.4744 20.0552 19.8568C20.6791 20.0641 21.3472 20.1765 22.0416 20.1765C25.487 20.1765 28.2799 17.4112 28.2799 14C28.2799 10.5888 25.487 7.82354 22.0416 7.82354C21.3472 7.82354 20.6791 7.9359 20.0552 8.14328ZM12.4764 14C12.4764 13.3124 12.3629 12.651 12.1535 12.0332C12.7774 12.2406 13.4454 12.3529 14.1399 12.3529C14.8345 12.3529 15.5025 12.2406 16.1265 12.0332C15.9169 12.651 15.8035 13.3124 15.8035 14C15.8035 14.6877 15.9169 15.349 16.1265 15.9669C15.5025 15.7594 14.8345 15.6471 14.1399 15.6471C13.4454 15.6471 12.7774 15.7594 12.1535 15.9669C12.3629 15.349 12.4764 14.6877 12.4764 14ZM14.1399 9.88235C16.2071 9.88235 17.8829 8.22317 17.8829 6.17646C17.8829 4.12976 16.2071 2.47059 14.1399 2.47059C12.0728 2.47059 10.397 4.12976 10.397 6.17646C10.397 8.22317 12.0728 9.88235 14.1399 9.88235ZM14.1399 25.5294C16.2071 25.5294 17.8829 23.8703 17.8829 21.8235C17.8829 19.7768 16.2071 18.1177 14.1399 18.1177C12.0728 18.1177 10.397 19.7768 10.397 21.8235C10.397 23.8703 12.0728 25.5294 14.1399 25.5294ZM25.7846 14C25.7846 16.0467 24.1089 17.7059 22.0416 17.7059C19.9745 17.7059 18.2988 16.0467 18.2988 14C18.2988 11.9533 19.9745 10.2941 22.0416 10.2941C24.1089 10.2941 25.7846 11.9533 25.7846 14ZM6.2382 17.7059C8.30536 17.7059 9.98113 16.0467 9.98113 14C9.98113 11.9533 8.30536 10.2941 6.2382 10.2941C4.17104 10.2941 2.49529 11.9533 2.49529 14C2.49529 16.0467 4.17104 17.7059 6.2382 17.7059ZM45.4865 7.9968C44.3055 7.08288 42.8191 6.62592 41.0273 6.62592C39.6427 6.62592 38.4278 6.93504 37.3826 7.55328C36.3374 8.15808 35.5229 9.01152 34.9392 10.1136C34.3691 11.2157 34.084 12.4723 34.084 13.8835C34.084 15.2813 34.3691 16.5312 34.9392 17.6333C35.5229 18.7354 36.3374 19.5955 37.3826 20.2138C38.4414 20.8186 39.6563 21.121 41.0273 21.121C42.8191 21.121 44.3055 20.664 45.4865 19.7501C46.6675 18.8362 47.448 17.593 47.8281 16.0205H44.8146C44.5024 16.7866 44.0137 17.3914 43.3485 17.8349C42.697 18.2784 41.9097 18.5002 40.9866 18.5002C40.2264 18.5002 39.5409 18.312 38.9301 17.9357C38.3192 17.5594 37.8441 17.0218 37.5048 16.3229C37.1654 15.624 36.9957 14.8109 36.9957 13.8835C36.9957 12.9427 37.1654 12.1229 37.5048 11.424C37.8441 10.7251 38.3192 10.1875 38.9301 9.8112C39.5409 9.43488 40.2264 9.24672 40.9866 9.24672C41.9097 9.24672 42.697 9.46848 43.3485 9.912C44.0137 10.3555 44.5024 10.9603 44.8146 11.7264H47.8281C47.448 10.1539 46.6675 8.91072 45.4865 7.9968ZM55.7445 15.456L59.1041 21H62.2805L58.6969 15.3149C59.8371 15.073 60.7059 14.5891 61.3032 13.8634C61.914 13.1376 62.2194 12.2371 62.2194 11.1619C62.2194 9.8448 61.7783 8.78304 60.8959 7.97664C60.0272 7.17024 58.758 6.76704 57.0883 6.76704H51.6111V21H54.482V15.456H55.7445ZM56.844 13.5005H54.482V9.16608H56.844C57.6856 9.16608 58.3032 9.36096 58.6969 9.75072C59.1041 10.127 59.3077 10.6579 59.3077 11.3434C59.3077 12.7814 58.4865 13.5005 56.844 13.5005ZM68.6579 9.02496V12.7142H73.7483V14.8915H68.6579V18.7219H74.3591V21H65.7869V6.76704H74.3591V9.02496H68.6579ZM89.9029 21H93.4458L96.9683 6.76704H93.853L91.654 17.7946L88.783 6.76704H85.627L82.7764 17.7946L80.5773 6.76704H77.462L80.9845 21H84.5071L87.2152 10.6781L89.9029 21Z"
              fill="#0B455F"
            />
          </g>
          <defs>
            <clipPath id="clip0_772_1717">
              <rect width="97" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
        </form>
      </div>


    </div>
  );
};
